import classNames from 'classnames';
import spriteUrl from '@/assets/icons/icon-sprite.svg?url';
import styles from './icon.module.scss';

export type IconSize = 8 | 10 | 12 | 14 | 16 | 20 | 24 | 32 | 40 | 48 | 52 | 56;

export interface IconProps {
  /** The class name to apply */
  className?: string;
  /** The name of the icon to show */
  name: IconName;
  /** The size of the icon to show */
  size?: IconSize;
  /** A title to show when hovering the icon */
  title?: string;
}

// Icons are symbols in a per-app sprite (see generate-icon-sprite.js), so they
// add no JavaScript and the sprite is downloaded once and cached
const Icon = ({ className, name, size = 16, title }: IconProps) => {
  return (
    <div className={classNames(styles.component, className)} title={title}>
      <svg
        aria-hidden="true"
        className={styles.icon}
        focusable="false"
        height={size}
        width={size}
      >
        <use href={`${spriteUrl}#${name}`} />
      </svg>
    </div>
  );
};

Icon.displayName = 'Icon';

export default Icon;
